import { ListItemText, ListItemButton, Typography } from "@mui/material";

export default function EmptyItem() {
  return (
    <ListItemButton>
      <ListItemText primary={<Typography>(empty)</Typography>} />
    </ListItemButton>
  );
}
